import script from "./travelRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./travelRecord.vue?vue&type=script&setup=true&lang=js"

import "./travelRecord.vue?vue&type=style&index=0&id=82b24fbc&lang=scss"

const __exports__ = script;

export default __exports__